<template>
  <transition name="fade">
    <div
      class="search-overlay"
      v-if="show"
      @keyup.esc="close"
      tabindex="-1"
      role="dialog"
    >
      <div class="search-overlay__content">
        <SearchInput
          ref="input"
          :placeholder="placeholder"
          v-model="query"
          @keydown.native.enter="submit"
        />
      </div>

      <div class="search-overlay__meta">
        <button
          type="button"
          class="search-overlay__close"
          @click="close"
          @keyup.enter="close"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import homeUrl from "../mixins/homeUrl";
import CloseIcon from "../Icons/CloseIcon.vue";
import SearchInput from "./SearchInput.vue";

export default {
  mixins: [homeUrl],
  name: "SearchOverlay",
  components: {SearchInput, CloseIcon},
  props: {
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: false,
      query: "",
    };
  },
  mounted() {
    document.addEventListener("openSearch", () => this.open());
  },
  destroyed() {
    document.removeEventListener('openSearch', this);
  },
  methods: {
    open() {
      this.show = true;

      this.$nextTick(() => this.$refs.input.focus());
    },

    close() {
      this.show = false;
    },

    sanitizeQuery(query) {
      // Remove HTML tags and encode for URL
      return encodeURIComponent(query.replace(/<[^>]*>/g, '').trim());
    },

    submit() {
      const sanitizedQuery = this.sanitizeQuery(this.query);
      window.location = `${this.homeUrl}search?q=${sanitizedQuery}`;
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/importall.scss";

.search-overlay {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100%;
  background: #44c4af;
  color: #fff;
  z-index: 200;
  padding: 8rem 3rem 3rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @include mq-tablet {
    padding: 8rem 3rem;
  }
}

.search-overlay__meta {
  position: fixed;
  top: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  color: #000;
}

.search-overlay__close {
  width: 4rem;
  height: 4rem;
  top: 2rem;
  right: 2rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  @include mq-tablet {
    width: 3rem;
    height: 3rem;
  }

  &:hover {
    opacity: 0.6;
  }

  .close-icon {
    fill: #fff;
  }
}
</style>
